import { render, staticRenderFns } from "./App.vue?vue&type=template&id=07edab11&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=07edab11&prod&scoped=true&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=07edab11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07edab11",
  null
  
)

export default component.exports